// Image base URL from environment variable
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 'https://beacon-parenting.s3.eu-west-1.amazonaws.com';

